// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DarkModeSwitchController from "./dark_mode_switch_controller"
application.register("dark-mode-switch", DarkModeSwitchController)

import FloatingImageGridController from "./floating_image_grid_controller"
application.register("floating-image-grid", FloatingImageGridController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LinksController from "./links_controller"
application.register("links", LinksController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)
